<template>
  <b-modal
    id="modal-print-magazine"
    ref="bModal"
    :title="$t('grossing.modal.magazineSelect')"
    centered
    modal-class="printMagazineModal"
  >
    <b-row class="px-2">
      <b-col class="pt-3 pb-5">
        <b-row class="pb-3">
          <b-col>
            <b-form-checkbox
              v-model="onlyCompatibles"
              @change="onComptaiblesCheckboxChange"
            >
              {{ $t('diagnosis.labels.compatible') }}
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="form-label">
              <label>{{ $t('grossing.modal.magazine') }}
              </label>
            </div>
            <vt-combo-select
              v-model="selected"
              track-by="reportModelEnum"
              :custom-label="(value) => `${value.printer} - ${value.magazine}`"
              :options="options"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="cancel"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            size="sm"
            class="btn--primary"
            :disabled="!selected"
            @click="printOnMagazine"
          >
            <i
              class="fal fa-print mr-2"
              aria-hidden="true"
            />
            {{ $t('global.print') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import magazineInformationServices from '@/api/resources/common/magazineInformationServices'

export default {
    name: 'PrintMagazineModal',
    data() {
        return {
            onlyCompatibles: true,
            selected: null,
            options: [],
            portions: [],
            priorityId: null,
            sampleTypeId: null,
            topographicCodeId: null,
            onOk: () => {
            },
            onCancel: () => {
            }
        }
    },
    async created() {

    },
    methods: {
        cancel() {
            this.$refs.bModal.hide()
            this.onCancel()
        },
        async getFilteredMagazines(laboratoryId, priorityId, sampleTypeId, topographicCodeId) {
            const [error, response] = await this.toCall(magazineInformationServices.getFilteredMagazines(laboratoryId, priorityId, sampleTypeId, topographicCodeId))
            if (error) {
                this.showErrorModalGlobal(this.$t('grossing.error.loadingParameters'))
                return
            }
            this.options = response
        },
        async getAllConfiguratedMagazines(laboratoryId) {
            const [error, response] = await this.toCall(magazineInformationServices.getAllConfiguratedMagazines(laboratoryId))
            if (error) {
                this.showErrorModalGlobal(this.$t('grossing.error.loadingParameters'))
                return
            }
            this.options = response
        },
        async ask(getAllMagazines, laboratoryId, priorityId, sampleTypeId, topographicCodeId, onOk) {
            this.selected = null
            this.laboratoryId = laboratoryId
            this.sampleTypeId = sampleTypeId
            this.topographicCodeId = topographicCodeId
            this.priorityId = priorityId
            this.onlyCompatibles = !getAllMagazines
            await this.onComptaiblesCheckboxChange(this.onlyCompatibles)
            this.onOk = onOk || (() => {
            })
            if (this.options.length === 1) {
                this.selected = this.options[0]
                this.onOk(this.selected)
            } else {
                this.$refs.bModal.show()
            }
        },
        printOnMagazine() {
            this.$refs.bModal.hide()
            this.onOk(this.selected)
        },
        async onComptaiblesCheckboxChange(onlyCompatibles) {
            if (onlyCompatibles) {
                await this.getFilteredMagazines(this.laboratoryId, this.priorityId, this.sampleTypeId, this.topographicCodeId)
            } else {
                await this.getAllConfiguratedMagazines(this.laboratoryId)
            }
        }
    }
}
</script>

<style>

    .printMagazineModal .modal-dialog {
        max-width: 30%;
    }

    .printMagazineModal .modal-body {
        padding: 0.6rem 1.1rem 0 1.1rem !important;
    }

</style>

<style scoped>
    .printMagazineModal {
        color: #303133;
    }

</style>
